import script from "./assistant-suggestion-pills.vue?vue&type=script&setup=true&lang=ts"
export * from "./assistant-suggestion-pills.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__